import { z } from "zod";

export const NewsletterSchema = z.object({
  email: z.string().email("Email invalide"),
});
